import { CommonSearchInput } from 'components/common/form/search';
import { lightFormat, parseISO } from 'date-fns';
import { LOCAL_DATE_FORMAT } from 'lib_ts/enums/datetime.enums';
import { compact, uniq } from 'lodash';
import { useMemo } from 'react';
import { useVideosStore } from 'stores/use-videos-store';

interface IProps {
  onChange?: () => void;
}

export const VideosFilterDateAdded = (props: IProps) => {
  const filter = useVideosStore((s) => s.filter);
  const videos = useVideosStore((s) => s.videos);

  const options = useMemo(() => {
    return compact(
      uniq(
        videos.map((o) => lightFormat(parseISO(o._created), LOCAL_DATE_FORMAT))
      )
    ).map((o) => ({
      label: o,
      value: o,
    }));
  }, [videos]);

  return (
    <CommonSearchInput
      id="video-date-added"
      placeholder="common.date-added"
      options={options}
      values={filter.dateAdded}
      onChange={(v) => {
        useVideosStore.getState().mergeFilter({ dateAdded: v });
        props.onChange?.();
      }}
      multiple
      optional
      reverseSort
    />
  );
};
